export const BREAKPOINTS = {
  SMALL: 768,
  MEDIUM: 1024,
  LARGE: 1280,
  MAXIMUM: 1344,
};
